import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import { motion } from "framer-motion";

const servicesData = [
  {
    icon: "bi-gear-fill",
    title: "High-Quality Solution",
    description:
      "We deliver precision-engineered manufacturing solutions to ensure superior product quality, optimized performance, and long-term reliability.",
  },
  {
    icon: "bi-tags-fill",
    title: "Best in Price",
    description:
      "We offer cost-effective manufacturing services without compromising on quality, helping you stay competitive in today's market.",
  },
  {
    icon: "bi-truck-front-fill",
    title: "Delivery",
    description:
      "Reliable and timely logistics to ensure your products are delivered safely and efficiently, meeting every project deadline.",
  },
];

const Services = () => {
  return (
    <motion.section
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
    >
      <div className="row">
        <div className="col-12">
          <div
            className="container-fluid bsb-service-8 bsb-overlay border border-dark"
            style={{
              backgroundImage: `url('./manu.jpg')`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              opacity: 0.8,
            }}
          >
            <div className="row justify-content-lg-around align-items-md-center">
              {servicesData.map((service, index) => (
                <motion.div
                  className="col-12 col-lg-4"
                  key={index}
                  initial={{ opacity: 0, y: 50 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: index * 0.2 }}
                  viewport={{ once: true }}
                >
                  <div className="card border-0 bg-transparent text-center">
                    <div className="card-body text-center p-4 p-xxl-5">
                      <motion.i
                        className={`bi ${service.icon} text-danger mb-4`}
                        style={{ fontSize: "56px" }}
                        whileHover={{ scale: 1.1 }}
                        transition={{ duration: 0.3 }}
                      ></motion.i>
                      <h4 className="text-white mb-4">{service.title}</h4>
                      <p className="text-white mb-4">{service.description}</p>
                    </div>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </motion.section>
  );
};

export default Services;
